
const PROD_BASE_URL = 'https://garen-server.onrender.com';
const DEV_BASE_URL = 'http://localhost:5000';

export const BASE_URL = (process.env.REACT_APP_BASE_URL || '').trim() ||
  (process.env.NODE_ENV === 'production' ? PROD_BASE_URL : DEV_BASE_URL);  